import { render, staticRenderFns } from "./PriceCardImgBigYingyou.vue?vue&type=template&id=60f5b97e&scoped=true&"
import script from "./PriceCardImgBigYingyou.vue?vue&type=script&lang=js&"
export * from "./PriceCardImgBigYingyou.vue?vue&type=script&lang=js&"
import style0 from "./PriceCardImgBigYingyou.vue?vue&type=style&index=0&id=60f5b97e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f5b97e",
  null
  
)

export default component.exports